export default __webpack_public_path__ + "static/media/887.4079da96.gif";